import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (id) => {
  const endpoint = `${apiEndpoints.sites}/${id}/clone`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.post(URL, null, { withCredentials: true }))
}
